export default "__VITE_ASSET__DWGG8My7__"